import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const MoreOutline = ({ width = 30, height = 30, color = '#38383E', ...props }: IconProps) => (
  <SvgComponent width={width}
    height={height}
    viewBox='0 0 30 30'
    {...props}
  >
    <path
      fill={color}
      d='M7.636 13.16a1.84 1.84 0 1 1 0 3.681 1.84 1.84 0 0 1 0-3.682Zm7.364 0a1.84 1.84 0 1 1 0 3.681 1.84 1.84 0 0 1 0-3.682Zm7.364 0a1.84 1.84 0 1 1 0 3.681 1.84 1.84 0 0 1 0-3.682Z'
    />
  </SvgComponent>
);

export default MoreOutline;
